import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './InfoTooltip.css';

const InfoTooltip = ({ children, text }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);
    const tooltipRef = useRef(null);

    const showTooltip = () => {
        if (!triggerRef.current) return;
        const triggerRect = triggerRef.current.getBoundingClientRect();
        
        // Position tooltip below the trigger element, relative to the viewport
        setPosition({
            top: triggerRect.bottom + 12, // Increased gap to 12px
            left: triggerRect.left + triggerRect.width / 2,
        });
        setIsVisible(true);
    };

    const hideTooltip = () => {
        setIsVisible(false);
    };

    // This effect ensures the tooltip is centered after it renders and we know its width
    useEffect(() => {
        if (isVisible && tooltipRef.current) {
            const tooltipWidth = tooltipRef.current.offsetWidth;
            setPosition(pos => ({
                ...pos,
                left: pos.left - tooltipWidth / 2,
            }));
        }
    }, [isVisible]);

    const tooltipElement = (
        <div 
            className="info-tooltip" 
            ref={tooltipRef}
            style={{ 
                top: `${position.top}px`, 
                left: `${position.left}px`,
                visibility: isVisible ? 'visible' : 'hidden'
            }}
        >
            {text}
        </div>
    );

    return (
        <>
            {React.cloneElement(children, {
                ref: triggerRef,
                onMouseEnter: showTooltip,
                onMouseLeave: hideTooltip,
            })}
            {ReactDOM.createPortal(tooltipElement, document.body)}
        </>
    );
};

export default InfoTooltip;
